import React from 'react';
import style from './interior.scss';

function InteriorButton(props) {
    const { isDone, onSelect, label, category } = props;
    let dotClass = style.dot;
    if (isDone) {
        dotClass = style.dot__done;
    }
    const onClick = () => onSelect(category);
    return (
        <div className={style.container} onClick={() => onClick()}>
            <span className={style.label}>{label}</span>
            <div className={dotClass} />
        </div>
    );
}

export default InteriorButton;
